import { render, staticRenderFns } from "./StepFormInfo.vue?vue&type=template&id=3230d2a5&scoped=true"
import script from "./StepFormInfo.vue?vue&type=script&lang=js"
export * from "./StepFormInfo.vue?vue&type=script&lang=js"
import style0 from "./StepFormInfo.vue?vue&type=style&index=0&id=3230d2a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230d2a5",
  null
  
)

export default component.exports